import folderStore from 'owa-folders';
import { isStringNullOrWhiteSpace } from 'owa-strings';
export default function isFolderNameValid(name) {
    // Valid folder name means the name string is not white space, or null, or empty
    // and it is not duplicated with existing categories
    return !isStringNullOrWhiteSpace(name) && !isFolderNameDuplicate(name.trim());
}
/**
 * Determines whether a folder has duplicate name with existing categories
 * @param name of the folder to be checked
 * @returns true if a folder does not have duplicate name with a folder in the root
 */
export function isFolderNameDuplicate(name) {
    return folderStore.rootFolder.childFolderIds.some(function (firstLevelFolderId) {
        return folderStore.folderTable.get(firstLevelFolderId).DisplayName.toLocaleLowerCase() ===
            name.toLocaleLowerCase();
    });
}
//# sourceMappingURL=isFolderNameValid.js.map